import React, { useState, useEffect } from "react";
import '../styles/other.css';
import '../styles/components.css';
import '../styles/tiles.css';

import { PieChart } from 'react-minimal-pie-chart';
import { numberWithSpaces } from '../utilities/OtherUtilities.js';

class FinDashboardPieGraph extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    getTotalCountOfValues = (array) => {
        var result = 0;
        array.forEach((item, index) => {
            result = result + item.value;
        });
        return result;
    }

    render(){
        return(
            <div className="universalTile flex verticalStack">
                <div className="responsiveThreeDotsContainer">
                    <span className="fontPoppinsSemiBold15 responsiveThreeDots">{this.props.title}<span className="fontPoppinsRegular13DarkGray"> {this.props.subtitle}</span></span>
                </div>

                <div style={{height: 10}}></div>

                <div style={{position: "relative"}}>
                    <PieChart
                        style={{height: 150}}
                        lineWidth={35}
                        paddingAngle={1}
                        labelPosition={82}
                        label={({ dataEntry }) => dataEntry.value}
                        labelStyle={{fill: "white", fontFamily: "PoppinsMedium", fontSize: 6}}
                        data={this.props.data}
                    />

                    <div style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)"}}>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                            <img style={{width: "30px", height: "30px"}} src={this.props.icon}/>
                            <span className="fontPoppinsRegular13Orange" style={{fontSize: 10}}>{numberWithSpaces(this.getTotalCountOfValues(this.props.data))} {this.props.currencyIso}</span>
                        </div>
                    </div>
                </div>

                <div style={{height: 20}}></div>

                <div className="horizontalStack">

                    <div className="flex"></div>

                    <div style={{width: "100%", display: "grid", gridTemplateColumns: "auto auto", gap: 10, columnGap: 20}}>

                        {this.props.data.map(function (item) {
                            return (
                                <div className="horizontalStackCenter">
                                    <div className="responsiveThreeDotsContainer flex">
                                        <div className="horizontalStackCenter">
                                            <div style={{minWidth: 15, width: 15, aspectRatio: "1/1", backgroundColor: item.color, borderRadius: 20}}></div>
                                            <span className="fontPoppinsMedium9 responsiveThreeDots" title={item.title} style={{marginLeft: 5}}>{item.title}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        }.bind(this))}

                    </div>

                    <div className="flex"></div>

                </div>

            </div>
        );
	}
}

export default FinDashboardPieGraph;